import { useEffect, useState } from "react";
import RewardSummaryList from "./RewardSummaryList.jsx";

function SuccessModal({ submission, error, submitting, onConfirm, onClose, onReset }) {
  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    if (submission) {
      setIsConfirmed(false);
    }
  }, [submission]);

  if (!submission) return null;

  const isCompleted = Boolean(submission.confirmationId);
  const selectedProducts = submission.products || (submission.product ? [submission.product] : []);
  const statusMessage =
    submission.stageStatus === "queued"
      ? "Your redemption request has been staged successfully and sent into the backend processing flow."
      : "Your redemption request was accepted by the frontend/backend flow and is still using the local fallback staging mode.";

  return (
    <div className="landstar-modal-backdrop">
      <div className="landstar-modal">
        <p className="landstar-kicker">
          {isCompleted ? "Redemption Complete" : "Final Review"}
        </p>
        <h2>
          {isCompleted
            ? "Reward request submitted successfully"
            : "Please confirm your redemption details"}
        </h2>
        <p>
          {isCompleted
            ? statusMessage
            : "Review the reward and shipping details below. If everything looks right, confirm the submission to continue."}
        </p>
        <div className="landstar-summary-card landstar-modal-summary-card">
          <p className="landstar-kicker">Reward Summary</p>
          <RewardSummaryList products={selectedProducts} />

          <div className="landstar-driver-summary-row landstar-summary-metadata">
            <div className="landstar-driver-summary-item">
              <span className="landstar-driver-summary-label">Tier</span>
              <strong>{submission.driver.rewardTier}</strong>
            </div>

            <div className="landstar-driver-summary-item">
              <span className="landstar-driver-summary-label">Eligibility</span>
              <strong>{submission.driver.tierYear}</strong>
            </div>

            <div className="landstar-driver-summary-item">
              <span className="landstar-driver-summary-label">L-Number</span>
              <strong>{submission.driver.lNumber}</strong>
            </div>

            {isCompleted ? (
              <div className="landstar-driver-summary-item">
                <span className="landstar-driver-summary-label">Confirmation</span>
                <strong>{submission.confirmationId}</strong>
              </div>
            ) : null}

            {isCompleted ? (
              <div className="landstar-driver-summary-item">
                <span className="landstar-driver-summary-label">Stage Status</span>
                <strong>{submission.stageStatus}</strong>
              </div>
            ) : null}
          </div>
        </div>

        <div className="landstar-checkout-card landstar-modal-address-card">
          <div className="landstar-section-heading">
            <p className="landstar-kicker">Shipping Details</p>
            <h3>Delivery information</h3>
          </div>
          <div className="landstar-success-grid">
            <p><strong>Name:</strong> {submission.form.firstName} {submission.form.lastName}</p>
            <p><strong>Email:</strong> {submission.form.email}</p>
            <p><strong>Phone:</strong> {submission.form.phone}</p>
            <p><strong>Driver Code:</strong> {submission.form.driverCode}</p>
            <p><strong>Address 1:</strong> {submission.form.address1}</p>
            <p><strong>Address 2:</strong> {submission.form.address2 || "N/A"}</p>
            <p><strong>City:</strong> {submission.form.city}</p>
            <p><strong>State / Region:</strong> {submission.form.state}</p>
            <p><strong>ZIP / Postal:</strong> {submission.form.zip}</p>
            <p><strong>Country:</strong> {submission.form.country}</p>
          </div>
        </div>
        {!isCompleted ? (
          <label className="landstar-confirm-checkbox">
            <input
              type="checkbox"
              checked={isConfirmed}
              onChange={(event) => setIsConfirmed(event.target.checked)}
            />
            <span>
              I confirm these rewards and shipping details are correct and ready for submission.
            </span>
          </label>
        ) : null}
        <div className="landstar-inline-actions">
          {isCompleted ? (
            <button type="button" className="landstar-primary-button" onClick={onReset}>
              Start Another Redemption
            </button>
          ) : (
            <>
              <button type="button" className="landstar-secondary-button" onClick={onClose}>
                Back to Edit
              </button>
              <button
                type="button"
                className="landstar-primary-button"
                onClick={onConfirm}
                disabled={submitting || !isConfirmed}
              >
                {submitting ? "Submitting..." : "Confirm Submission"}
              </button>
            </>
          )}
        </div>
        {!isCompleted && error ? <p className="landstar-error">{error}</p> : null}
      </div>
    </div>
  );
}

export default SuccessModal;
